import React from 'react'

const FasterIcon = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={60}
                height={60}
                x={0}
                y={0}
                viewBox="0 0 512 512"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className=""
            >
                <g>
                    <path
                        fill="#9dc6fb"
                        fillRule="evenodd"
                        d="M255.52 79.891h40.187v41.736H255.52z"
                        clipRule="evenodd"
                        opacity={1}
                        data-original="#9dc6fb"
                    />
                    <path
                        fill="#ffd54f"
                        d="M40.658 217.434a7.071 7.071 0 0 1 7.071-7.071h71.654a7.07 7.07 0 1 1 0 14.142H47.729a7.071 7.071 0 0 1-7.071-7.071zm-3.944 43.385h71.711a7.07 7.07 0 1 0 0-14.142H36.714a7.07 7.07 0 1 0 0 14.142zm76.086 29.215a7.071 7.071 0 0 0-7.071-7.071H7.571a7.07 7.07 0 1 0 0 14.142h98.159a7.072 7.072 0 0 0 7.07-7.071zm5.077 36.314a7.071 7.071 0 0 0-7.071-7.071H36.714a7.07 7.07 0 1 0 0 14.142h74.092a7.07 7.07 0 0 0 7.071-7.071zm6.727 29.244H47.729a7.07 7.07 0 1 0 0 14.142h76.875a7.07 7.07 0 1 0 0-14.142z"
                        opacity={1}
                        data-original="#ffd54f"
                        className=""
                    />
                    <path
                        fill="#eb4c56"
                        d="M168.611 159.535a7.06 7.06 0 0 1-5.723-2.911l-22.317-30.664a7.07 7.07 0 0 1 1.556-9.877 7.07 7.07 0 0 1 9.878 1.556l22.317 30.664a7.07 7.07 0 0 1-5.711 11.232z"
                        opacity={1}
                        data-original="#eb4c56"
                    />
                    <path
                        fill="#fe646f"
                        d="M125.728 139.915a7.07 7.07 0 0 1-4.169-12.787l37.376-27.222a7.07 7.07 0 0 1 8.326 11.431l-37.376 27.222a7.047 7.047 0 0 1-4.157 1.356z"
                        opacity={1}
                        data-original="#fe646f"
                        className=""
                    />
                    <path
                        fill="#fe646f"
                        fillRule="evenodd"
                        d="M275.599 454.54c93.626 0 170.013-76.358 170.013-169.984s-76.387-170.013-170.013-170.013-169.984 76.387-169.984 170.013c-.001 93.626 76.358 169.984 169.984 169.984z"
                        clipRule="evenodd"
                        opacity={1}
                        data-original="#fe646f"
                        className=""
                    />
                    <path
                        fill="#8bb6ed"
                        fillRule="evenodd"
                        d="M229.589 56.428h92.049v29.574h-92.049z"
                        clipRule="evenodd"
                        opacity={1}
                        data-original="#8bb6ed"
                    />
                    <path
                        fill="#eb4c56"
                        fillRule="evenodd"
                        d="M275.599 432.366c81.435 0 147.84-66.405 147.84-147.811 0-81.435-66.405-147.84-147.84-147.84-81.407 0-147.811 66.405-147.811 147.84 0 81.407 66.404 147.811 147.811 147.811z"
                        clipRule="evenodd"
                        opacity={1}
                        data-original="#eb4c56"
                    />
                    <path
                        fill="#e8f0fe"
                        fillRule="evenodd"
                        d="M275.599 419.717c74.465 0 135.19-60.725 135.19-135.161 0-74.465-60.725-135.19-135.19-135.19-74.436 0-135.161 60.725-135.161 135.19-.001 74.436 60.724 135.161 135.161 135.161z"
                        clipRule="evenodd"
                        opacity={1}
                        data-original="#e8f0fe"
                        className=""
                    />
                    <path
                        d="M383.911 291.626h-10.355a7.07 7.07 0 1 1 0-14.142h10.355a7.07 7.07 0 1 1 0 14.142zM352.186 368.214a7.054 7.054 0 0 1-5.01-2.08l-7.315-7.343a7.07 7.07 0 0 1 .02-10 7.07 7.07 0 0 1 10 .019l7.315 7.343a7.07 7.07 0 0 1-5.01 12.061z"
                        fill="#000000"
                        opacity={1}
                        data-original="#000000"
                    />
                    <path
                        fill="#407093"
                        d="M282.669 176.242v10.355a7.071 7.071 0 0 1-14.142 0v-10.355a7.071 7.071 0 0 1 14.142 0zm-7.07 199.172a7.07 7.07 0 0 0-7.071 7.071v10.384a7.071 7.071 0 0 0 14.142 0v-10.384a7.071 7.071 0 0 0-7.071-7.071zm81.587-172.445a7.068 7.068 0 0 0-10 0l-7.315 7.315a7.07 7.07 0 1 0 10 9.999l7.315-7.315a7.07 7.07 0 0 0 0-9.999zM201.344 348.81l-7.314 7.343a7.07 7.07 0 0 0 5.01 12.06 7.05 7.05 0 0 0 5.01-2.081l7.314-7.343a7.07 7.07 0 0 0-.02-9.999 7.07 7.07 0 0 0-10 .02zm-23.674-71.326h-10.355a7.07 7.07 0 1 0 0 14.142h10.355a7.07 7.07 0 1 0 0-14.142zm23.684-57.202a7.043 7.043 0 0 0 5 2.071 7.07 7.07 0 0 0 4.999-12.07l-7.314-7.315a7.07 7.07 0 1 0-9.999 9.999zM278.525 282.335a7.071 7.071 0 0 1-6.692-9.358l17.871-52.321a7.071 7.071 0 0 1 13.382 4.572l-17.871 52.321a7.073 7.073 0 0 1-6.69 4.786z"
                        opacity={1}
                        data-original="#407093"
                    />
                    <path
                        fill="#ffd54f"
                        fillRule="evenodd"
                        d="M422.75 244.512v22.145a84.107 84.107 0 0 1 28.57 11.847l15.662-15.662a106.61 106.61 0 0 1 24.755 24.726l-15.69 15.69a83.867 83.867 0 0 1 11.847 28.57h22.173a106.382 106.382 0 0 1 1.434 17.497c0 5.967-.488 11.789-1.434 17.498h-22.173a84.107 84.107 0 0 1-11.847 28.57l15.69 15.662a106.734 106.734 0 0 1-24.755 24.755l-15.662-15.69a84.119 84.119 0 0 1-28.57 11.847v22.173c-5.708.946-11.531 1.434-17.498 1.434s-11.818-.488-17.498-1.434v-22.173a83.867 83.867 0 0 1-28.57-11.847l-15.69 15.69a106.61 106.61 0 0 1-24.726-24.755l15.662-15.691a84.245 84.245 0 0 1-11.818-28.541H300.44a106.644 106.644 0 0 1-1.463-17.498c0-5.966.516-11.818 1.463-17.497h22.144a85.034 85.034 0 0 1 11.847-28.57l-15.662-15.69a106.486 106.486 0 0 1 24.726-24.726l15.69 15.662a83.867 83.867 0 0 1 28.57-11.847v-22.145c5.68-.947 11.531-1.463 17.498-1.463s11.789.516 17.497 1.463z"
                        clipRule="evenodd"
                        opacity={1}
                        data-original="#ffd54f"
                        className=""
                    />
                    <path
                        fill="#ffc328"
                        fillRule="evenodd"
                        d="M405.253 412.947c35.052 0 63.622-28.57 63.622-63.622s-28.57-63.651-63.622-63.651-63.651 28.598-63.651 63.651 28.598 63.622 63.651 63.622z"
                        clipRule="evenodd"
                        opacity={1}
                        data-original="#ffc328"
                    />
                    <path
                        fill="#e8f0fe"
                        fillRule="evenodd"
                        d="M405.253 400.469c28.168 0 51.145-22.976 51.145-51.144s-22.976-51.144-51.145-51.144c-28.168 0-51.144 22.976-51.144 51.144s22.976 51.144 51.144 51.144z"
                        clipRule="evenodd"
                        opacity={1}
                        data-original="#e8f0fe"
                        className=""
                    />
                    <path
                        fill="#fe646f"
                        d="M275.599 265.523c-10.479 0-19.004 8.537-19.004 19.032 0 10.479 8.525 19.004 19.004 19.004 10.494 0 19.032-8.525 19.032-19.004 0-10.495-8.538-19.032-19.032-19.032z"
                        opacity={1}
                        data-original="#fe646f"
                        className=""
                    />
                </g>
            </svg>

        </>
    )
}

export default FasterIcon